/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withFormik, Form, Field } from "formik";
import Yup from "yup";
import { goBack, push } from "react-router-redux";
import { string, bool, shape, arrayOf } from "prop-types";
import { actions as ecomexActions, selectors as ecomexSelectors } from "reducers/ecomex";

import Notification from "pages/_components/Notification";

import { actions as formActions, selectors as formSelectors } from "reducers/form";
import { selectors as thirdPaymentSelector } from "reducers/thirdPayment";
import { selectors as sessionSelectors } from "reducers/session";

import Col from "react-bootstrap/lib/Col";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import Credential from "pages/_components/fields/credentials/Credential";
import Container from "pages/_components/Container";
import Head from "pages/_components/Head";
import PageLoading from "pages/_components/PageLoading";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

import * as i18n from "util/i18n";
import { flattenArray, removeDuplicateItems } from "util/array";

class TransactionTicketCancelConfirmation extends Component {
    static propTypes = {
        isDesktop: bool,
        dispatch: shape({}).isRequired,
        credentials: arrayOf(string).isRequired,
        isSubmitting: bool.isRequired,
        isLoading: bool.isRequired,
        withOutLoader: bool.isRequired,
        cancelTransactionData: shape({}).isRequired,
        pageToGoBack: string,
        location: shape({
            state: shape({
                goBackState: string,
            }),
        }),
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        isDesktop: true,
        embeddedInV3Shell: false,
        pageToGoBack: null,
        location: null,
    };

    componentDidMount() {
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, cancelTransactionData, pageToGoBack, location } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.cancelTransactionData !== cancelTransactionData ||
                prevProps.pageToGoBack !== pageToGoBack ||
                prevProps.location?.state !== location?.state)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop, cancelTransactionData, pageToGoBack, location } = this.props;
        const titleText = cancelTransactionData?.fullTitle || i18n.get(cancelTransactionData?.title);
        const headerTitle = titleText ? titleText.replace(/\*/g, "") : "";
        const goBackPath = pageToGoBack || location?.state?.goBackState || "/v3/dashboard";
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["cancelTransaction"],
            headerTitle,
            goBackPath,
        });
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell, pageToGoBack, location } = this.props;
        const path = pageToGoBack || location?.state?.goBackState;
        if (embeddedInV3Shell) {
            dispatch(push(path || "/v3/dashboard"));
            return;
        }
        dispatch(goBack());
    };

    centerContentMobile = () => {
        const { cancelTransactionData } = this.props;
        return (
            <div className="title-account-header-multiline-background-blue">
                <h1 style={{ margin: "0.2rem" }}>
                    {cancelTransactionData?.fullTitle || i18n.get(cancelTransactionData?.title)}
                </h1>
            </div>
        );
    };

    render() {
        const {
            credentials,
            isSubmitting,
            isLoading,
            withOutLoader,
            cancelTransactionData,
            isDesktop,
            embeddedInV3Shell,
        } = this.props;
        const titleText = cancelTransactionData?.fullTitle || i18n.get(cancelTransactionData?.title);

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="cancelTransaction" />}
                <div className={isDesktop ? "admin-detail-head px-0" : ""}>
                    {(!embeddedInV3Shell || isDesktop) && (
                        <Head
                            onBack={this.handleBack}
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            centerElement={isDesktop ? undefined : this.centerContentMobile}
                        />
                    )}
                    {isDesktop && (!isLoading || withOutLoader) && (
                        <div className="view-title">
                            <h1>{titleText.replaceAll("*", "")} </h1>
                        </div>
                    )}
                </div>
                <div className={`confirmation__container ${!isDesktop && "container-white"}`}>
                    <PageLoading loading={!(!isLoading || withOutLoader)}>
                        <Container
                            className="align-items-center flex-grow px-0 container--layout with-margin mb-0"
                            gridClassName="confirmation__form confirmation__box">
                            <div className="admin-content-center" style={{ marginBottom: "2rem" }}>
                                <I18n id="cancel.check.transaction" component="h2" />
                            </div>
                            <Col className="col-12" lg={12} md={12} sm={12}>
                                {cancelTransactionData?.content}

                                <Form>
                                    {credentials.map((credential) => (
                                        <div key={credential}>
                                            <Field
                                                idForm="form.credential"
                                                name={credential}
                                                component={Credential}
                                                type={credential}
                                                placeholderText={i18n.get(`confirmation.otp.placeholder`)}
                                                otpTxt={
                                                    <div className="admin-content-center">
                                                        <I18n id="transfer.summary.confirm.label" />
                                                    </div>
                                                }
                                                withoutOtpTxt={
                                                    <div className="admin-content-center">
                                                        <I18n
                                                            id="confirmation.withoutotp.text"
                                                            component="p"
                                                            componentProps={{
                                                                className: "confirmation__text-without-otp",
                                                            }}
                                                        />
                                                    </div>
                                                }
                                            />
                                        </div>
                                    ))}
                                    <div className="d-flex justify-content-center">
                                        <Button
                                            type="submit"
                                            label="global.confirm"
                                            bsStyle="primary"
                                            loading={isSubmitting}
                                            image="images/arrowRight.svg"
                                            imageStyle="mr-2"
                                            className="text-capitalize"
                                        />
                                    </div>
                                </Form>
                            </Col>
                        </Container>
                    </PageLoading>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    credentials: compose(
        (array) => array.filter((item) => item !== "accessToken"),
        removeDuplicateItems,
        flattenArray,
        (array) => array.map(({ credentials }) => credentials),
    )(formSelectors.getCredentialsGroups(state)),
    isLoading: formSelectors.getFetching(state),
    cancelTransactionData: formSelectors.getCancelTransactionData(state),
    user: sessionSelectors.getUser(state),
    pageToGoBack: thirdPaymentSelector.getPageToGoBack(state),
    summary: ecomexSelectors.getSummary(state),
    userId: sessionSelectors.getUser(state).userId,
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: ({ credentials }) =>
            credentials.reduce((values, credential) => ({ ...values, [credential]: "" }), { otp: "" }),
        validationSchema: ({ credentials }) =>
            Yup.object().shape(
                credentials.reduce(
                    (values, credential) => ({
                        ...values,
                        [credential]: Yup.string().required(i18n.get(`form.credential.${credential}.required`)),
                    }),
                    {},
                ),
            ),
        handleSubmit: (credentials, formikBag) => {
            const { dispatch, summary, cancelTransactionData, user } = formikBag.props;
            const cancelType = cancelTransactionData?.title;
            let cancelByMenu = false;
            if (cancelType === "activities.thirdpay.table.menu.decline") {
                cancelByMenu = true;
            }
            const cancel = {
                credentials,
                formikBag,
                idTransaction: cancelTransactionData?.idTransaction,
                userId: user.userId,
                rejectedTransactions: cancelByMenu,
                force: cancelTransactionData?.force,
            };
            if (summary?.idActivity === "ecomex.send.accept.transaction") {
                const { userId } = formikBag.props;
                const { transactionData } = summary;
                const { requestIdEcomex } = transactionData;
                const otp = Object.values(credentials)[0];
                const ecomexTransaction = {
                    userId,
                    idEnvironment: summary?.idEnvironment,
                    lang: summary?.lang,
                    channel: summary?.channel,
                    transactionData: summary?.transactionData,
                    _otp: otp,
                    ecomexRequest: requestIdEcomex,
                    deleting: true,
                    idTrx: summary?.idTransaction,
                };

                dispatch(ecomexActions.rejectTransactionInPending(ecomexTransaction, cancel));
                return;
            }
            dispatch(formActions.cancelTransaction(cancel));
        },
    }),
    resizableRoute,
)(TransactionTicketCancelConfirmation);
